import { atom } from "jotai";
import { atomEffect } from "jotai-effect";

const MENU_KIND = {
    options: "options",
    project: "project",
    url: "url",
} as const;
export type MenuKind = (typeof MENU_KIND)[keyof typeof MENU_KIND];

export { MENU_KIND };

export const errorAtom = atom<unknown>(null);
export const searchQueryAtom = atom("");
export const menuKindAtom = atom<MenuKind>(MENU_KIND.options);

/**
 * This determines whether the menu shown is fixed.
 * When the kind prop is provided to ContextSelectorMenu, the menu shown is fixed to that.
 */
export const isFixedMenuKindAtom = atom(false);

export const canGoBackAtom = atom((get) => get(menuKindAtom) !== MENU_KIND.options && !get(isFixedMenuKindAtom));

export const clearSearchQueryAtomEffect = atomEffect((get, set) => {
    const menuKind = get(menuKindAtom);
    if (menuKind === MENU_KIND.options) {
        set(searchQueryAtom, "");
    }
});

export const clearErrorAtomEffect = atomEffect((get, set) => {
    get(menuKindAtom);
    get(searchQueryAtom);
    set(errorAtom, null);
});

export const isParsingUrlAtom = atom(false);
export const pendingContextUrlAtom = atom("");
export const isFetchingProjectsAtom = atom(false);
